import React from "react";
import { Done, Clear } from "@material-ui/icons";
import { Grid } from "@material-ui/core";
import { STDoneButton, STClearButton } from "./styles";

interface IProps {
  onSubmit: () => void;
  onClose: () => void;
}

export const ButtonsForm = (props: IProps) => (
  <Grid container justify="center">
        <STDoneButton onClick={props.onSubmit} className={"custom-expired-session-modal-submit-button"} variant="contained" color="primary">
      <Done />
    </STDoneButton>
        <STClearButton onClick={props.onClose} className={"custom-expired-session-modal-close-button"} variant="contained">
      <Clear />
    </STClearButton>
  </Grid>
);
